import { css } from '@linaria/core'
import { colors } from '../theme'

export const avatarBgCss = css`
  [data-gray-avatar] & {
    fill: transparent;
  }
`

export const avatarFaceCss = css`
  [data-gray-avatar] & {
    fill: ${colors.gray10};
  }
  [data-gray-avatar][data-night] & {
    fill: ${colors.gray40};
  }
`

export const avatarShadowCss = css`
  [data-gray-avatar] & {
    fill: ${colors.gray20};
  }
`

export const avatarHairCss = css`
  [data-gray-avatar] & {
    fill: ${colors.gray40};
  }
  [data-gray-avatar][data-night] & {
    fill: ${colors.gray10};
  }
`

export const avatarShirtCss = css`
  [data-gray-avatar] & {
    fill: ${colors.gray30};
  }
`
